import React from 'react';
import { useHistory } from 'react-router';
import { useSelector } from 'react-redux';

// Types
import { GoalItem } from 'Shared/constants/types';
import { UserSuggestion } from 'Shared/types/UserSuggestion.type';

// Utils
import PageUrlsUtils from 'Shared/utils/PageUrls.utils';

// Hooks
import { useUserSuggestion } from 'Shared/utils/hooks/use-user-suggestion';

// Selectors
import * as GoalsSelectors from 'Shared/selectors/Goals.selectors';

// Components
import BaseUserSuggestionItem from './BaseUserSuggestionItem';
import GoalIcon from 'Shared/components/Goals/GoalIcon';

type Props = {
  userSuggestion: UserSuggestion;
  className?: string;
};

const GoalReminderSuggestion = ({ userSuggestion, className }: Props) => {
  const history = useHistory();
  const { handleUpdateCompletedAt } = useUserSuggestion({ userSuggestion });

  const goal: GoalItem =
    useSelector(state => GoalsSelectors.getGoalBySlug(state, { slug: userSuggestion.suggestablePublicId }))?.toJS() ||
    null;

  const handleOnClick = () => {
    handleUpdateCompletedAt();
    history.push({
      pathname: PageUrlsUtils.makeGoalDetailPageUrl(userSuggestion.suggestablePublicId),
      state: { modal: true },
    });
  };

  return (
    <BaseUserSuggestionItem
      userSuggestion={userSuggestion}
      btnLabel="View Goal"
      onClick={handleOnClick}
      image={<GoalIcon icon={goal.icon} status={goal.status} size="xl" rounded />}
      className={className}
    />
  );
};

export default GoalReminderSuggestion;
